import React, { useState, useEffect } from "react";
import { useMediaQuery } from "react-responsive";
import { useNavigate } from "react-router-dom";
import { useJob } from "../../context/JobContext";
import { useAgreement } from "../../context/AgreementContext";
import { useOutletContext } from "react-router-dom";
import ApproveStartComponent from "../../components/fs-account/jobs-section/manage-workers/ApproveStartComponent";
import config from "../../config/config";
import { timeAgo } from "../../util_functions/helpers";
import { FaMapMarkerAlt, FaFire, FaChevronDown, FaChevronUp } from "react-icons/fa";
import { IoIosCheckmarkCircleOutline } from "react-icons/io";
import { AiOutlineSchedule } from "react-icons/ai";

const DashboardComponent = () => {
  const { clientUser } = useOutletContext();
  const userId = clientUser?.id;
  const today = new Date();
  const [selectedDate, setSelectedDate] = useState(today.getDate());

  const { jobs, fetchJobsByClientId } = useJob();
  const { agreements, listAgreementsByUser } = useAgreement();

  const [hoveredJobId, setHoveredJobId] = useState(null);
  const [openSection, setOpenSection] = useState("jobs");

  const isMobile = useMediaQuery({ minWidth: 320, maxWidth: 1200 });

  const toggleSection = (section) => {
    setOpenSection((prev) => (prev === section ? null : section));
  };
  const navigate = useNavigate();

  useEffect(() => {
    if (userId) {
      fetchJobsByClientId(userId);
      listAgreementsByUser("client", userId).catch(console.error);
    }
  }, [userId, fetchJobsByClientId, listAgreementsByUser]);

  const handleDateClick = (day) => {
    setSelectedDate(day);
    console.log("Selected day is :", day);
  };

  const viewJobDetails = (jobId) => {
    console.log(`Viewing details for job ID: ${jobId}`);
    navigate(`/account/ps-dashboard/job-listings/open/${jobId}`);
  };

  const daysInMonth = new Date(
    today.getFullYear(),
    today.getMonth() + 1,
    0
  ).getDate();
  const firstDayIndex = new Date(
    today.getFullYear(),
    today.getMonth(),
    1
  ).getDay();

  const handleMouseEnter = (jobId) => {
    setHoveredJobId(jobId);
  };

  const handleMouseLeave = () => {
    setHoveredJobId(null);
  };

  const truncateTitle = (title, wordLimit) => {
    const words = title.split(" ");
    if (words.length > wordLimit) {
      return words.slice(0, wordLimit).join(" ") + "...";
    }
    return title;
  };

  const yourJobsContent =
    jobs.length > 0 ? (
      <div className="recommended-jobs-container">
        {jobs.slice(0, 5).map((job) => (
          <div
            key={job.id}
            className="job-item-dashboard"
            onMouseEnter={() => handleMouseEnter(job.id)}
            onMouseLeave={handleMouseLeave}
            onClick={() => viewJobDetails(job.id)}
          >
            <h3>
              {hoveredJobId === job.id
                ? job.jobCraftDetails.jobTitle
                : truncateTitle(job.jobCraftDetails.jobTitle, 8)}
            </h3>
            <p className="job-detail-dashboard">
              <span className="job-detail-label">
                <FaMapMarkerAlt className="job-detail-icon fa-map-marker-alt" />
                <strong>Location</strong>
                <span className="user-dashboard-arrow">➤</span>
              </span>
              <span className="job-detail-value">{job.suburbValue}</span>
            </p>
            <p className="job-detail-dashboard">
              <span className="job-detail-label">
                <IoIosCheckmarkCircleOutline className="job-detail-icon chckmrk-outline" />
                <strong>Support Frequency</strong>
                <span className="user-dashboard-arrow">➤</span>
              </span>
              <span className="job-detail-value">{job.frequencyDetails.supportType}</span>
            </p>
            <p className="job-detail-dashboard">
              <span className="job-detail-label">
                <AiOutlineSchedule className="job-detail-icon fa-clock" />
                <strong>Date Posted</strong>
                <span className="user-dashboard-arrow">➤</span>
                <strong>{timeAgo(job.postedTime)}</strong> </span><span className="job-detail-value">ago</span>
            </p>
            <p className="job-detail-dashboard">
              <FaFire className="job-detail-icon fa-applications" />
              <span className="application-count">
                <strong>
                  {job.applicationCount}
                  {job.applicationCount > 15 ? "+" : ""}
                </strong>{" "}
                application{job.applicationCount !== 1 ? "s" : ""}
              </span>
            </p>
          </div>
        ))}
      </div>
    ) : (
      <div className="no-jobs-placeholder">
        <img
          src="/images/no_results_found.png"
          alt="No results found"
          className="no-jobs-image"
        />
        <p>No jobs posted yet.</p>
      </div>
    );

  const announcementsContent = (
    <div className="announcements-container">
      <div className="right-column-item">
        <h2>Tax and super calculators</h2>
        <p>
          Specify a date range and the percentage of your Will Care payments
          that you want to set aside for income tax or superannuation, and we
          will calculate the amount.
        </p>
      </div>
      <div className="right-column-item">
        <h2>Will Care Tax Benefits Program</h2>
        <p>
          We’ve partnered with YOUtax to give you exclusive discounts of 20% off
          tax returns and 40% off quarterly BAS filing.
        </p>
      </div>
      <div className="right-column-item">
        <h2>Tax and super calculators</h2>
        <p>
          Specify a date range and the percentage of your Will Care payments
          that you want to set aside for income tax or superannuation, and we
          will calculate the amount.
        </p>
      </div>
      <div className="right-column-item">
        <h2>Will Care Tax Benefits Program</h2>
        <p>
          We’ve partnered with YOUtax to give you exclusive discounts of 20% off
          tax returns and 40% off quarterly BAS filing.
        </p>
      </div>
      <div className="right-column-item">
        <h2>Will Care Tax Benefits Program</h2>
        <p>
          We’ve partnered with YOUtax to give you exclusive discounts of 20% off
          tax returns and 40% off quarterly BAS filing.
        </p>
      </div>
      <div className="right-column-item">
        <h2>Will Care Tax Benefits Program</h2>
        <p>
          We’ve partnered with YOUtax to give you exclusive discounts of 20% off
          tax returns and 40% off quarterly BAS filing.
        </p>
      </div>
      <div className="right-column-item">
        <h2>Will Care Tax Benefits Program</h2>
        <p>
          We’ve partnered with YOUtax to give you exclusive discounts of 20% off
          tax returns and 40% off quarterly BAS filing.
        </p>
      </div>
    </div>
  );

  const notificationsContent = (
    <div className="dashboard-notification-section">
      <ApproveStartComponent
          />
      <div className="dashboard-alerts-container">
        {!clientUser?.isEmailVerified && (
          <div className="notification-item">
            <div className="icon-container alert" />
            <p>
              <strong>Email</strong> verification pending.
            </p>
          </div>
        )}
        {!clientUser?.phoneNumberVerified && (
          <div className="notification-item">
            <div className="icon-container alert" />
            <p>
              <strong>Phone number</strong> verification pending.
            </p>
          </div>
        )}
      </div>
    </div>
  );

  return (
    <>
      {isMobile ? (
        <div className="dwc-accordion">
          <div className="dwc-accordion-item">
            <button
              className={`dwc-accordion-header ${openSection === "notifications" ? "open" : ""
                }`}
              onClick={() => toggleSection("notifications")}
            >
              <span>Alerts / Notifications</span>
              {openSection === "notifications" ? (
                <FaChevronUp className="dwc-accordion-icon" />
              ) : (
                <FaChevronDown className="dwc-accordion-icon" />
              )}
            </button>

            {openSection === "notifications" && (
              <div className="dwc-accordion-content">
                {notificationsContent}
              </div>
            )}
          </div>

          <div className="dwc-accordion-item">
            <button
              className={`dwc-accordion-header ${openSection === "announcements" ? "open" : ""
                }`}
              onClick={() => toggleSection("announcements")}
            >
              <span>Announcements & Updates</span>
              {openSection === "announcements" ? (
                <FaChevronUp className="dwc-accordion-icon" />
              ) : (
                <FaChevronDown className="dwc-accordion-icon" />
              )}
            </button>

            {openSection === "announcements" && (
              <div className="dwc-accordion-content">
                {announcementsContent}
              </div>
            )}
          </div>

          <div className="dwc-accordion-item">
            <button
              className={`dwc-accordion-header ${openSection === "jobs" ? "open" : ""
                }`}
              onClick={() => toggleSection("jobs")}
            >
              <span>Your Posted Jobs</span>
              {openSection === "jobs" ? (
                <FaChevronUp className="dwc-accordion-icon" />
              ) : (
                <FaChevronDown className="dwc-accordion-icon" />
              )}
            </button>

            {openSection === "jobs" && (
              <div className="dwc-accordion-content">
                {yourJobsContent}
              </div>
            )}
          </div>
        </div>
      ) : (
        <div className="dashboard-welcome-container">
          <div className="dashboard-right-column">
            <h1 className="recommended-jobs-header">
              Your Posted Jobs
            </h1>
            {yourJobsContent}
          </div>
          <div className="dashboard-right-column">
            <h1 className="dashboard-updates-header">
              Announcements & Updates
            </h1>
            {announcementsContent}
          </div>
          <div className="dashboard-right-column">
            <h1 className="dashboard-notifications-header">
              Alerts / Notifications
            </h1>
            {notificationsContent}
          </div>
        </div>
      )}
    </>
  );
};

export default DashboardComponent;
